import React, { useEffect, useRef, useState } from 'react';
import ChatMessage from './ChatMessage';
import useAuth from '../../hooks/useAuth';
import { chatService } from '../../services/api';

const ChatWindow = ({ messages, conversationId, isAuthenticated }) => {
  const messagesEndRef = useRef(null);
  const [feedbackStatus, setFeedbackStatus] = useState({});

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Fetch feedback status when messages change
  useEffect(() => {
    const fetchFeedbackStatus = async () => {
      try {
        // Get message IDs from messages that have them
        const messageIds = messages
          .filter(msg => msg.message_id)
          .map(msg => msg.message_id);

        if (messageIds.length > 0) {
          const status = await chatService.getFeedbackStatus(messageIds);
          setFeedbackStatus(status);
        }
      } catch (error) {
        console.error('Error fetching feedback status:', error);
      }
    };

    if (isAuthenticated) {
      fetchFeedbackStatus();
    }
  }, [messages, isAuthenticated]);

  return (
    <div className="flex-1 overflow-y-auto bg-white">
      <div className="container mx-auto max-w-4xl">
        {messages.map((message, index) => (
          <ChatMessage
            key={index}
            message={message}
            isAuthenticated={isAuthenticated}
            conversationId={conversationId}
            feedbackStatus={message.message_id ? feedbackStatus[message.message_id] : null}
          />
        ))}
      </div>
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatWindow;
